import { render, staticRenderFns } from "./SpecialBiwakoG1.vue?vue&type=template&id=645f9990&scoped=true"
import script from "./SpecialBiwakoG1.vue?vue&type=script&lang=js"
export * from "./SpecialBiwakoG1.vue?vue&type=script&lang=js"
import style0 from "./SpecialBiwakoG1.vue?vue&type=style&index=0&id=645f9990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f9990",
  null
  
)

export default component.exports